import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {
  primaryShade1,
  primaryShade3,
  red,
  white,
  black
} from "../styles/color";
import moment from "moment";
const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
class PaidInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }
  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };
  getDateValueNumber = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let year = currentDate.getFullYear();

    let dateMonthYear = date + "-" + month + "-" + year;
    return dateMonthYear;
  };
  render() {
    const { paidInvoices } = this.props;
    return paidInvoices.length > 0 ? (
      <div
        style={{
          height: "calc(100vh - 160px)",
          overflow: "scroll"
        }}
      >
        {paidInvoices.map(data => (
          <div
            style={{
              padding: "10px"
            }}
          >
            <Card style={{ borderRadius: "10px" }} expanded={true}>
              <CardContent
                style={{ padding: "0px" }}
                aria-expanded={this.state.expanded}
                aria-label="View All"
              >
                <div
                  style={{
                    margin: "10px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      height: "40px",
                      backgroundColor: primaryShade1,
                      justifyContent: "space-between",
                      color: white,
                      alignItems: "center",
                      padding: "0px 10px 0px 10px"
                    }}
                  >
                    <span>
                      <strong style={{ color: black }}>BILL : </strong>
                      <strong>{data.invoiceNumber}</strong>
                    </span>
                    <span>
                      <strong>
                        {this.getDateValueNumber(data.invoiceDate)}
                      </strong>
                    </span>
                  </div>
                </div>
              </CardContent>
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "7px",
                    padding: "7px",
                    alignItems: "center",
                    fontSize: "0.8em"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      backgroundColor: primaryShade3,
                      borderRadius: "10px",
                      minWidth: "110px",
                      padding: "0px 5px"
                    }}
                  >
                    <span>DEALS</span>
                    <hr style={{ height: "20px" }} />
                    <span>{data.dealsTotalQuantity} Ton</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      backgroundColor: primaryShade3,
                      borderRadius: "10px",
                      minWidth: "110px",
                      padding: "0px 5px"
                    }}
                  >
                    <span>BROKERAGE</span>
                    <hr style={{ height: "20px" }} />
                    <span>&#8377; {data.invoiceAmount}</span>
                    <span />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          height: "calc(100vh - 160px)",
          justifyContent: "space-around",
          alignItems: "center"
        }}
      >
        <h3>No Invoices Paid Yet...</h3>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(PaidInvoice));
